module.exports = __webpack_public_path__ + "static/media/Gallery 5.914fd01d.svg";